import { Action, ActionCreator, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IApplicationState } from '../store'
import { IAarCombinatieSelectie } from '../../../shared/models/IAarCombinatieSelectie'
import { IUpdateKoppelingRequest } from '../../../shared/models/PostRequestModel'
import { IResponseAction } from '../interfaces'
import GlnService from '../../../shared/service/GlnService'
import { IExtendedKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'

export enum Actions {
  ClearDataRequest = 'ClearDataRequest',
  ClearDataResponse = 'ClearDataResponse',
  GetCombinatieDataRequest = 'GetCombinatieDataRequest',
  GetCombinatieDataResponse = 'GetCombinatieDataResponse',
  UpdateKoppelingenRequestAction = 'UpdateKoppelingenRequestAction',
  UpdateKoppelingenResponseAction = 'UpdateKoppelingenResponseAction',
  ChangeKoppelingAction = 'ChangeKoppelingenAction',
}

export interface IClearDataRequestAction
  extends Action<Actions.ClearDataRequest> {}
export interface IClearDataResponseAction
  extends IResponseAction<Actions.ClearDataResponse> {
  payload: string
}
export interface IGetCombinatieDataRequestAction
  extends Action<Actions.GetCombinatieDataRequest> {
  payload: IAarCombinatieSelectie
}
export interface IGetCombinatieDataResponseAction
  extends IResponseAction<Actions.GetCombinatieDataResponse> {
  payload: ILocatieGlnModel[]
}
export interface IUpdateKoppelingenRequestAction
  extends Action<Actions.UpdateKoppelingenRequestAction> {
  payload: IUpdateKoppelingRequest[]
  selection: IAarCombinatieSelectie
}
export interface IUpdateKoppelingenResponseAction
  extends IResponseAction<Actions.UpdateKoppelingenResponseAction> {
  payload: ILocatieGlnModel[]
}
export interface IChangeKoppelingAction
  extends Action<Actions.ChangeKoppelingAction> {
  payload: IExtendedKoppeling
  value: string
  canCombine: boolean
}

export type CombinatieActions =
  | IClearDataRequestAction
  | IClearDataResponseAction
  | IGetCombinatieDataRequestAction
  | IGetCombinatieDataResponseAction
  | IUpdateKoppelingenRequestAction
  | IUpdateKoppelingenResponseAction
  | IChangeKoppelingAction

export const updateKoppelingenCreator: ActionCreator<
  ThunkAction<
    Promise<IUpdateKoppelingenResponseAction>,
    IApplicationState,
    null,
    IUpdateKoppelingenResponseAction
  >
> = (
  koppelRequest: IUpdateKoppelingRequest[],
  selection: IAarCombinatieSelectie
) => {
  return async (dispatch: Dispatch, request) => {
    const requestDataAction: IUpdateKoppelingenRequestAction = {
      type: Actions.UpdateKoppelingenRequestAction,
      payload: koppelRequest,
      selection: selection,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.updateKoppelingen(koppelRequest)

      if (result.success) {
        const newData = await GlnService.getKoppelingenVoorCombinaties(
          selection
        )
        const response: IUpdateKoppelingenResponseAction = {
          success: result.success,
          errorMessage: result.errorMessage,
          type: Actions.UpdateKoppelingenResponseAction,
          payload: newData.payLoad,
        }

        return dispatch(response)
      } else {
        const failResponse: IUpdateKoppelingenResponseAction = {
          success: false,
          payload: null,
          errorMessage: `Fout bij opslaan koppelingen: ${result.errorMessage}`,
          type: Actions.UpdateKoppelingenResponseAction,
        }
        return dispatch(failResponse)
      }
    } catch (e) {
      const errorResponse: IUpdateKoppelingenResponseAction = {
        success: false,
        payload: null,
        errorMessage: `Fout bij opslaan koppelingen: ${e.message}`,
        type: Actions.UpdateKoppelingenResponseAction,
      }
      return dispatch(errorResponse)
    }
  }
}

export const getKoppelingenCreator: ActionCreator<
  ThunkAction<
    Promise<IGetCombinatieDataResponseAction>,
    IApplicationState,
    null,
    IGetCombinatieDataResponseAction
  >
> = (selectie: IAarCombinatieSelectie) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetCombinatieDataRequestAction = {
      type: Actions.GetCombinatieDataRequest,
      payload: selectie,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.getKoppelingenVoorCombinaties(selectie)
      const response: IGetCombinatieDataResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetCombinatieDataResponse,
      }

      if (result.success && result.payLoad.length === 0) {
        response.success = false
        response.errorMessage = 'Geen koppelingen gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetCombinatieDataResponseAction = {
        success: false,
        errorMessage: `Fout bij ophalen koppelingen: ${e.message}`,
        payload: null,
        type: Actions.GetCombinatieDataResponse,
      }
      return dispatch(errorResponse)
    }
  }
}

export const clearDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IClearDataResponseAction>,
    IApplicationState,
    null,
    IClearDataResponseAction
  >
> = (message: string) => {
  return async (dispatch: Dispatch, getState) => {
    const requestClearAction: IClearDataRequestAction = {
      type: Actions.ClearDataRequest,
    }
    dispatch(requestClearAction)
    const clearResponse: IClearDataResponseAction = {
      success: true,
      type: Actions.ClearDataResponse,
      payload: message,
    }
    return dispatch(clearResponse)
  }
}

export const changeKoppelingActionCreator: ActionCreator<
  ThunkAction<
    Promise<IChangeKoppelingAction>,
    IApplicationState,
    null,
    IChangeKoppelingAction
  >
> = (koppeling: IExtendedKoppeling, value: string, canCombine: boolean) => {
  return async (dispatch: Dispatch, getState) => {
    const request: IChangeKoppelingAction = {
      type: Actions.ChangeKoppelingAction,
      payload: koppeling,
      value: value,
      canCombine: canCombine,
    }
    return dispatch(request)
  }
}
